import { GlobalComboboxStyles } from '@ben/orion/combobox';
import Button from '@ben/orion/deprecated-button';
import { IconName } from '@ben/orion/icon';
import Typography, { TypographyVariant } from '@ben/orion/typography';
import {
  ModularBenefitCustomModalType,
  type IModularBenefitDetail,
} from '@ben/shared/types/columbia';
import { Menu } from '@mantine/core';
import { toast } from 'react-toastify';
import { HeaderContainer, TitleContainer } from './opt-in-out-modal.styles';

interface HeaderProps {
  onAddModal: (type: ModularBenefitCustomModalType) => void;
  customModals: IModularBenefitDetail['customModals'];
}

export const Header = ({ onAddModal, customModals }: HeaderProps) => {
  const handleAddModal = (type: ModularBenefitCustomModalType) => {
    if (customModals?.some((modal) => modal.type === type)) {
      toast.error('Only one custom modal per modal type is allowed.');
      return;
    }
    onAddModal(type);
  };

  return (
    <HeaderContainer>
      <GlobalComboboxStyles />
      <TitleContainer>
        <Typography variant={TypographyVariant.h3}>Custom modals</Typography>
        {(!Array.isArray(customModals) || customModals.length === 0) && (
          <Typography variant={TypographyVariant.bodyMd1}>
            No custom modal has been implemented for this benefit. Default
            modals will be displayed.
          </Typography>
        )}
      </TitleContainer>
      <Menu>
        <Menu.Target>
          <Button
            label="Add custom modal"
            iconName={IconName.ArrowsDown}
            isRightIcon
            width="fit-content"
          />
        </Menu.Target>
        <Menu.Dropdown>
          <Menu.Item
            onClick={() => handleAddModal(ModularBenefitCustomModalType.OPT_IN)}
          >
            <Typography variant={TypographyVariant.bodyMd1}>
              Opt-In modal
            </Typography>
          </Menu.Item>
          <Menu.Item
            onClick={() =>
              handleAddModal(ModularBenefitCustomModalType.OPT_OUT)
            }
          >
            <Typography variant={TypographyVariant.bodyMd1}>
              Opt-Out modal
            </Typography>
          </Menu.Item>
          <Menu.Item
            onClick={() => handleAddModal(ModularBenefitCustomModalType.CHANGE)}
          >
            <Typography variant={TypographyVariant.bodyMd1}>
              Change modal
            </Typography>
          </Menu.Item>
        </Menu.Dropdown>
      </Menu>
    </HeaderContainer>
  );
};
